import React from "react";
import { StyleSheet, Text, TextInput, View } from "react-native";

type Props = {
  /** フォームの名前を指定します */
  label: string;
  /** 選択の値を定義します */
  value: any;
  /** 変更の処理を定義します */
  onChange?: (e: string) => void;
  /**
   *  デフォルト：false
   *
   * 操作可能：false 操作不可：true */
  disabled?: boolean;
};

/**
 * １行のテキストフォームを作成します
 * @param param0
 * @returns
 */
export const InputForm = ({ value, onChange, disabled, label }: Props) => {
  return (
    <View style={styles.container}>
      <Text style={styles.label}>{label}</Text>
      <TextInput
        value={value}
        editable={disabled ?? false}
        selectTextOnFocus={false}
        style={[styles.input, disabled ?? false ? styles.able : styles.disable]}
        onChangeText={onChange}
        inputAccessoryViewID={"1"}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingBottom: 20,
  },
  label: {
    fontSize: 20,
  },
  input: {
    fontSize: 16,
    paddingVertical: 7,
    paddingHorizontal: 7,
    borderWidth: 1,
    borderColor: "gray",
    borderRadius: 4,
    backgroundColor: "darkgray",
    color: "gray",
    width: "100%",
  },
  able: {
    color: "black",
    backgroundColor: "white",
  },
  disable: {
    color: "black",
    backgroundColor: "darkgray",
  },
});
